import { FC } from 'react'
import { ProviderType } from '@expane/data'
import { LiqPayIcon, PlataByMonoIcon } from 'ui/Icons'

export const PaymentProviderIcon: FC<{ type: ProviderType; size?: number }> = ({ type, size }) => {
  if (type === ProviderType.liqPay) return <LiqPayIcon size={size} />

  if (type === ProviderType.monobank) return <PlataByMonoIcon size={size} />

  return null
}
